// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle9 from "../../randing/RandingStyle9";

function Randing007({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_02.jpg`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_btn_send.png`}
      companyName="춘천청춘플란트"
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_03.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_04.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_05.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_06.jpg`}
      img7Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_07.jpg`}
      img8Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_08.jpg`}
      img9Path={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_09.jpg`}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/007/241108_footer.jpg`}
    />
  );
}

export default Randing007;
